var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1280 1280",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-3020)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "peercoin-leaf-green-transparent",
    transform: "matrix(1,0,0,1,0,3020)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1280,
    height: 1280,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.25916,0,0,5.25916,-2648.31,-3965.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M645.897,997.002C641.831,997.347 638.609,997.427 636.638,997.431C572.294,997.561 520.054,945.191 520.054,880.846C520.054,880.329 520.057,879.814 520.064,879.299L520.064,877.66L520.054,877.66L520.054,754.075L520.064,754.075L520.064,754.075L520.064,754.075C559.111,753.466 655.459,761.973 708.592,835.882C722.349,855.018 730.454,878.484 730.454,903.828C730.454,919.039 727.534,933.573 722.225,946.9L722.189,946.87C718.783,955.903 709.72,974.515 686.076,986.369C682.271,988.276 678.386,989.858 674.54,991.168C691.509,926.208 669.328,832.097 570.781,786.872C630.63,823.973 677.905,917.397 645.897,997.002Z",
    style: {
      fill: "rgb(255,255,255)"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.981a385adf1cab1173e7d3ab5bb63665.svg";
export { ForwardRef as ReactComponent };